import 'core-js/fn/array/some';
import 'core-js/fn/array/from';
import 'core-js/fn/array/find-index';
import 'core-js/fn/object/assign';



// WEBPACK FOOTER //
// ./polyfill.js